import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=63c17fce&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=63c17fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c17fce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c17fce')) {
      api.createRecord('63c17fce', component.options)
    } else {
      api.reload('63c17fce', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=63c17fce&scoped=true&", function () {
      api.rerender('63c17fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dcuZ8QvOZUD2/JS/comp/SearchFilterTokens.vue"
export default component.exports